const state = {
  constructionData: [],
};

const getters = {
  constructions: (state) => state.constructionData,
};

const actions = {
  async updateData({ commit }, id, data) {
    await commit("updateConstruction", id, data);
  },
  async setData({ commit }, objects) {
    await commit("setConstructionData", objects);
  },
};

const mutations = {
  updateConstruction(state, id, data) {
    state.constructionData[id] = data;
  },
  setConstructionData(state, objects) {
    state.constructionData = objects;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
